<div class="chart-container">
  <mat-card>
    <div class="chart-width">
      <canvas id="chartInvBedKb"></canvas>
    </div>
  </mat-card>
</div>